/* ==========================================================================
   By Eider Villamizar Dev — 03/08/2026
   mb-carousel.js — motor compartido de los carruseles de Mara Baby.

   Construido sobre el patron del carrusel "Esenciales", que lleva tiempo
   funcionando sin fallos en esta tienda. Las tres decisiones que lo hacen
   estable, y que aqui se respetan:

     1. NADA de scroll-snap-type en CSS. El ajuste magnetico del navegador
        pelea contra cualquier desplazamiento programatico: da tirones,
        cancela animaciones y deja tarjetas a medias. La alineacion se hace
        por aritmetica, que es predecible.

     2. Se desplaza con  rail.scrollLeft += x , dejando que la animacion la
        haga el CSS (scroll-behavior: smooth). Las asignaciones sucesivas se
        acumulan bien; scrollBy({behavior:'smooth'}) se pisa a si mismo.

     3. El salto del bucle nunca ocurre durante una animacion: siempre
        despues, con retardo, y con scroll-behavior en auto durante el salto.

   Un unico temporizador recursivo que decide en cada vuelta si avanza o se
   salta el turno. No se crea ni se destruye al entrar y salir con el cursor,
   que era el origen de los tirones.

   Uso desde una seccion:

     <div data-mb-carousel data-mb-speed="3" data-mb-hover="7" data-mb-infinite="true">
       <div data-mb-rail>
         <div data-mb-panel>...</div>          (opcional, panel fijo)
         <a data-mb-card data-mb-first>...</a>
         ...
         <a data-mb-card data-mb-loop>...</a>  (primera de la tanda repetida)
       </div>
     </div>
   ========================================================================== */

(function () {
  'use strict';

  var RETARDO_SALTO   = 400;  // ms tras iniciar un avance, antes de mirar el bucle
  var REPOSO_SCROLL   = 120;  // ms de calma para dar el scroll por terminado
  var MARCA_SCROLL    = 160;  // ms que se mantiene la clase is-scrolling

  function iniciar(root) {
    var rail = root.querySelector('[data-mb-rail]');
    if (!rail) return;

    var infinito = root.dataset.mbInfinite === 'true';
    var lapso    = Math.max(parseFloat(root.dataset.mbSpeed) || 3, 1) * 1000;
    var pausaMs  = Math.max(parseFloat(root.dataset.mbHover) || 0, 0);
    var auto     = root.dataset.mbAutoplay === 'true';
    var quieto   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    pausaMs = pausaMs * 1000;
    if (quieto) auto = false;

    var tanda       = 0;      // ancho de una tanda completa de productos
    var pausaHasta  = 0;
    var enPantalla  = true;
    var px = -1, py = -1;

    function aplazar() {
      if (pausaMs > 0) pausaHasta = Date.now() + pausaMs;
    }

    var arrastrando = false;  // arrastre confirmado (se supero el umbral)
    var pulsando    = false;  // boton del raton abajo, aun sin saber que sera
    var saltando    = false;
    var timer       = null;
    var tReposo     = null;
    var tMarca      = null;
    var tSalto      = null;

    /* ---------------- Medidas ---------------- */

    function paso() {
      var card = rail.querySelector('[data-mb-card]');
      if (!card) return rail.clientWidth;
      var cs = window.getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }

    function medirTanda() {
      var a = rail.querySelector('[data-mb-first]');
      var b = rail.querySelector('[data-mb-loop]');
      tanda = (a && b) ? Math.round(b.offsetLeft - a.offsetLeft) : 0;
    }

    /* ---------------- Bucle ----------------
       Se ejecuta con scroll-behavior en auto para que el reposicionamiento
       sea instantaneo e invisible, y solo cuando no hay nada animandose. */

    function sinAnimacion(fn) {
      saltando = true;
      var previo = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      fn();
      void rail.offsetWidth;                 // fuerza el recalculo
      rail.style.scrollBehavior = previo || '';
      saltando = false;
    }

    function revisarBucle() {
      if (!infinito || tanda <= 0 || arrastrando) return;
      var x = rail.scrollLeft;
      if (x >= tanda)      sinAnimacion(function () { rail.scrollLeft = x - tanda; });
      else if (x <= 0)     sinAnimacion(function () { rail.scrollLeft = x + tanda; });
    }

    /* ---------------- Desplazamiento ---------------- */

    function mover(direccion) {
      rail.scrollLeft += direccion * paso();
      if (tSalto) window.clearTimeout(tSalto);
      tSalto = window.setTimeout(revisarBucle, RETARDO_SALTO);
    }

    /* Alineacion por aritmetica: sustituye al scroll-snap del CSS sin pelearse
       con nada. Se aplica solo al soltar el raton.

       Si hay panel fijo, las posiciones de reposo NO son multiplos del paso:
       hay que descontar lo que el panel ocupa, o la tarjeta contigua queda
       cortada por la mitad. El origen se mide en vivo porque el panel esta
       pegado a la izquierda y su posicion depende del desplazamiento. */
    function origen() {
      var primera = rail.querySelector('[data-mb-first]');
      var panel   = root.querySelector('[data-mb-panel]');
      if (!primera) return 0;
      if (!panel) return 0;
      var bordePanel = panel.getBoundingClientRect().right -
                       rail.getBoundingClientRect().left;
      return primera.offsetLeft - bordePanel;
    }

    function alinear() {
      var p = paso();
      if (p <= 0) return;
      var o = origen();
      var destino = o + Math.round((rail.scrollLeft - o) / p) * p;
      if (destino < 0) destino = 0;
      if (Math.abs(destino - rail.scrollLeft) < 2) return;
      rail.scrollLeft = destino;
    }

    /* ---------------- Estado del scroll ---------------- */

    rail.addEventListener('scroll', function () {
      rail.classList.add('is-scrolling');
      if (tMarca) window.clearTimeout(tMarca);
      tMarca = window.setTimeout(function () {
        rail.classList.remove('is-scrolling');
      }, MARCA_SCROLL);

      pintarProgreso();

      if (saltando) return;
      if (tReposo) window.clearTimeout(tReposo);
      tReposo = window.setTimeout(revisarBucle, REPOSO_SCROLL);
    }, { passive: true });

    /* ---------------- Arrastre con raton ----------------

       En tactil el navegador se encarga solo del desplazamiento, por eso
       todo este bloque se salta con pointerType === 'touch'. Lo que sigue
       es solo para raton, y esta escrito con una regla en mente:

         entre el mousedown y el click, el carril NO se mueve.

       Si se mueve, el raton acaba sobre una tarjeta distinta de la que
       pulso, el navegador lanza el click en el ancestro comun (el carril)
       en vez de en el enlace, y el clic se pierde sin decir nada. Era lo
       que pasaba en escritorio: en el movil funcionaba porque este bloque
       ni siquiera se ejecuta. */

    var UMBRAL = 6;            // px a recorrer para considerarlo arrastre

    var xInicio = 0, sInicio = 0;
    var arrastreReal   = false; // se ha superado el umbral
    var bloquearHasta  = 0;     // marca de tiempo: clics anteriores se anulan

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.button !== 0) return;   // derecho y rueda intactos (abrir en pestana)

      pulsando     = true;
      arrastreReal = false;
      xInicio      = e.clientX;

      /* Congela el carril donde esta AHORA. Si venia una animacion del
         avance automatico, esta asignacion la corta en seco: sin ella la
         tarjeta sigue deslizandose bajo el cursor mientras se pulsa. */
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft = rail.scrollLeft;
      sInicio = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!pulsando) return;
      var d = e.clientX - xInicio;

      /* Hasta el umbral no es arrastre: un clic normal lleva dos o tres
         pixeles de temblor de mano y debe seguir siendo un clic. */
      if (!arrastreReal) {
        if (Math.abs(d) < UMBRAL) return;
        arrastreReal = true;
        arrastrando  = true;
        rail.classList.add('is-dragging');   // aqui, no en el pointerdown:
      }                                      // esa clase apaga los enlaces
      rail.scrollLeft = sInicio - d;
    });

    function soltar() {
      if (!pulsando) return;
      pulsando = false;

      var hubo = arrastreReal;
      arrastreReal = false;
      arrastrando  = false;
      rail.classList.remove('is-dragging');
      rail.style.scrollBehavior = '';        // no mueve nada por si solo

      /* Clic limpio: se sale sin tocar scrollLeft. Cualquier ajuste aqui
         se colaria entre el mouseup y el click y mataria la navegacion. */
      if (!hubo) return;

      /* Hubo arrastre: se anula el click que el navegador va a lanzar y ya
         se puede alinear con tranquilidad. */
      bloquearHasta = Date.now() + 350;
      alinear();
      window.setTimeout(revisarBucle, RETARDO_SALTO);
    }

    rail.addEventListener('pointerup', soltar);
    rail.addEventListener('pointercancel', soltar);
    rail.addEventListener('pointerleave', soltar);

    /* Un unico guardian permanente, por marca de tiempo. El anterior se
       registraba de nuevo en cada arrastre y solo se borraba a si mismo al
       recibir un clic: si el arrastre terminaba fuera del carril, se
       quedaba armado y se comia el siguiente clic bueno. */
    rail.addEventListener('click', function (e) {
      if (Date.now() >= bloquearHasta) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);

    /* ---------------- Flechas y barra de progreso ----------------
       Opcionales: si la seccion no las pinta, esto no hace nada. */

    var btnPrev = root.querySelector('[data-mb-prev]');
    var btnNext = root.querySelector('[data-mb-next]');
    var thumb   = root.querySelector('[data-mb-thumb]');

    function pintarProgreso() {
      if (infinito) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (thumb) {
        var visible = rail.clientWidth / Math.max(rail.scrollWidth, 1);
        thumb.style.width = Math.max(visible * 100, 10) + '%';
        var recorridoBarra = (100 / Math.max(visible, 0.0001)) - 100;
        var avance = max > 0 ? rail.scrollLeft / max : 0;
        thumb.style.transform = 'translateX(' + (avance * recorridoBarra) + '%)';
      }
      if (btnPrev) btnPrev.disabled = rail.scrollLeft <= 1;
      if (btnNext) btnNext.disabled = rail.scrollLeft >= max - 1;
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { aplazar(); mover(-1); });
    if (btnNext) btnNext.addEventListener('click', function () { aplazar(); mover(1); });

    /* ---------------- Avance automatico ----------------
       Un solo temporizador que nunca se destruye: en cada vuelta decide si
       avanza o pasa el turno. Asi no hay dos intervalos solapandose. */

    /* Con el boton abajo el carril no se mueve aunque la pausa por cursor
       este en 0: si avanza mientras se pulsa, el clic cae en otra tarjeta. */
    function bloqueado() {
      return pulsando || arrastrando || saltando || document.hidden ||
             Date.now() < pausaHasta || !enPantalla;
    }

    function ciclo() {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (!bloqueado()) mover(1);
        ciclo();
      }, lapso);
    }

    /* La pausa por cursor solo se renueva si el raton se mueve de verdad.
       Si alguien deja el cursor quieto sobre una tarjeta, pasada la pausa el
       carrusel sigue: las tarjetas que pasan por debajo no reinician nada. */

    if (auto) {
      rail.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'touch') aplazar();
      });
      rail.addEventListener('pointermove', function (e) {
        if (e.pointerType === 'touch') return;
        if (e.clientX === px && e.clientY === py) return;
        px = e.clientX;
        py = e.clientY;
        aplazar();
      }, { passive: true });
      rail.addEventListener('touchstart', aplazar, { passive: true });
      root.addEventListener('focusin', aplazar);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          enPantalla = entradas[0].isIntersecting;
        }, { threshold: 0.15 }).observe(root);
      }

      ciclo();
    }

    /* ---------------- Aparicion escalonada ---------------- */

    if ('IntersectionObserver' in window && !quieto) {
      var io = new IntersectionObserver(function (entradas) {
        if (entradas[0].isIntersecting) {
          root.classList.add('mb-visible');
          io.disconnect();
        }
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      root.classList.add('mb-visible');
    }

    /* ---------------- Recalculos ---------------- */

    function recalcular() {
      medirTanda();
      pintarProgreso();
    }

    window.addEventListener('resize', recalcular);
    window.addEventListener('load', recalcular);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(recalcular).catch(function () {});
    }
    recalcular();
  }

  function arrancarTodos(ambito) {
    var nodos = (ambito || document).querySelectorAll('[data-mb-carousel]');
    Array.prototype.forEach.call(nodos, function (el) {
      if (el.dataset.mbListo === '1') return;
      el.dataset.mbListo = '1';
      iniciar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arrancarTodos(); });
  } else {
    arrancarTodos();
  }

  /* El personalizador de Shopify recarga las secciones sin recargar la
     pagina. Sin esto, tras editar un ajuste el carrusel se queda muerto. */
  document.addEventListener('shopify:section:load', function (e) {
    arrancarTodos(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-mb-carousel]');
    if (el) el.dataset.mbListo = '';
  });
})();
